import LandingSubText from '../ui/landing-sub-text';
import Link from 'next/link';
import DynamicIcon from '../ui/dynamic-icon';
import { useState } from 'react';
import { useRouter } from 'next/router';
import LandingPageHeader from '../ui/landing-page-header';
import LandingPageContainer from '../ui/landing-page-container';
import LandingHeroHeading from '../ui/landing-hero-heading';
import LandingPageButton from '../ui/landing-page-button';
import Image from 'next/image';
import Landing from '../../pages';
import LandingHeadingText from '../ui/landing-heading-text';
import { prefix } from '../../lib/auth';
import HeroBackground from '../ui/hero-background.js';

const LandingPage = ({ children }) => {
    const router = useRouter();

    const howItWorksData = [
        {
            title: "Sign Up",
            description: "Create a developer account and accept platform terms to get started."
        },
        {
            title: "Access the SDK",
            description: "Join the waitlist to unlock the Workpeg SDK and development tools."
        },
        {
            title: "Build Your Peg",
            description: "Develop, test, and refine your Peg inside the Workpeg environment."
        },
        {
            title: "Publish & Earn",
            description: "Ship your Peg to the Peg Center and earn from real users."
        },
        {
            title: "Track Performance",
            description: "Monitor installs, usage, and revenue from your dashboard."
        }
    ];

    return (
        <div className='h-screen w-screen overflow-y-auto scrollbar-none lg:custom-scrollbar relative bg-white'>
            <HeroBackground>
                <div className='w-full h-[100dvh]'>
                    <LandingPageHeader />
                    <LandingPageContainer>
                        <div className='w-full m-auto grid h-[calc(100dvh-80px)] content-center'>
                            <div className='grid gap-[29px] lg:gap-[40px]'>
                                <div className='grid gap-[28px] '>
                                    <LandingHeroHeading additionalclasses='max-w-[680px] m-auto'>Build on the world most powerful AI OS</LandingHeroHeading>
                                    <LandingSubText additionalclasses='max-w-[680px] m-auto !text-white !text-[14px] lg:!text-[18px] leading-[14px] lg:!leading-[29px]'>Workpeg gives developers the tools to build powerful Pegs (apps) that run inside automated workspaces. Access the SDK, ship products, and earn from real users.</LandingSubText>
                                </div>
                                <LandingPageButton onClick={() => router.push(`http://${prefix()}accounts.workpeg.com/login?peg=developers`)}>Get Started</LandingPageButton>
                            </div>
                        </div>
                    </LandingPageContainer>
                </div>
            </HeroBackground>
            {/* <LandingPageContainer additionalclasses='border-dotted border-x-[1px] border-[#E7E7E7]'>
                <div className='w-full py-[76px] lg:py-[129px] grid lg:flex gap-[50px] lg:gap-[76px] justify-between items-center`'>
                    <div className='grid max-w-[480px]'>
                        <div className='mb-[20px] w-fit h-fit px-[20px] py-[5.8px] bg-[#E7E7E7] rounded-[99px] text-[16px] leading-[22.4px] tracking-[-0.64px] text-[#101010]'>
                            Developer SDK
                        </div>
                        <LandingHeadingText additionalclasses='!mb-[23px] !text-start !tracking-[-1.44px]'>One Platform. Infinite Pegs</LandingHeadingText>
                        <p className='text-[16px] lg:text-[20px] leading-[24px] lg:leading-[30px] text-[#101010] tracking-[-0.8px] mb-[31px] lg:mb-[40px]'>
                            The Workpeg Developer Platform lets you build modular tools called Pegs that plug directly into the Workpeg OS. These Pegs power real businesses across productivity, finance, communication, HR, and automation.
                        </p>
                        <div className='grid lg:flex items-center gap-[43px] lg:gap-[29px] pt-[23px] border-t-[1px] border-[#E7E7E7]'>
                            <div className='grid gap-[12.6px] lg:min-w-[225px]'>
                                <p className='font-semibold text-[18px] leading-[21px] tracking-[-0.72px] text-[#101010]'>Dev Tools</p>
                                <p className='text-[14px] leading-[18.2px] tracking-[-0.56px] text-[#101010]'>Libraries, templates, and components for fast Peg development.</p>
                            </div>
                            <div className='grid gap-[12.6px]'>
                                <p className='font-semibold text-[18px] leading-[21px] tracking-[-0.72px] text-[#101010]'>Peg Publishing</p>
                                <p className='text-[14px] leading-[18.2px] tracking-[-0.56px] text-[#101010]'>Publish your Peg to the Peg Center and reach thousands of organizations.</p>
                            </div>
                        </div>
                    </div>
                    <Image src='/images/dev-sdk.svg' alt='dev sdk' width={538} height={420} />
                </div>
            </LandingPageContainer> */}
            {/* <div className='bg-grey-900 w-full'>
                <LandingPageContainer additionalclasses='border-dotted lg:border-x-[1px] border-[#313131]'>
                    <div className='pt-[90px] pb-[63px] grid gap-[33px] lg:gap-[98px]'>
                        <div className='grid gap-[16px]'>
                            <LandingHeadingText additionalclasses='!text-white'>How It Works</LandingHeadingText>
                            <p className='text-[16px] lg:text-[20px] leading-[24px] lg:leading-[30px] text-[#fff] text-center tracking-[-0.8px] mb-[31px] lg:mb-[40px]'>
                                Here&apos;s what sets our agents apart
                            </p>
                        </div>
                        <div className='lg:max-w-[1000px] w-full m-auto grid lg:grid-cols-3'>
                            {howItWorksData.map((item, index) => (
                                <div key={index} className='h-[242px] grid gap-[16px] px-[32px] items-center justify-start content-center border-[1px] border-[#313131] border-dotted'>
                                    <p className='font-semibold text-[22px] leading-[21px] tracking-[-0.72px] text-[#ffffff]'>{item.title}</p>
                                    <p className='text-[18px] leading-[23px] tracking-[-0.72px] text-[#ffffff]'>{item.description}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </LandingPageContainer>
            </div> */}
            {/* <LandingPageContainer additionalclasses='border-dotted border-x-[1px] border-[#E7E7E7]'>
                <div className='w-full py-[76px] lg:py-[129px] grid lg:flex gap-[118px] lg:gap-[76px] justify-between items-center`'>
                    <Image src='/images/sdk.svg' alt='dev sdk' width={538} height={420} />
                    <div className='grid gap-[32px] content-start order-first lg:order-last'>
                        <div className='w-fit h-fit px-[20px] py-[5.8px] bg-[#E7E7E7] rounded-[99px] text-[16px] leading-[22.4px] tracking-[-0.64px] text-[#101010]'>
                            Api & Components
                        </div>
                        <LandingHeadingText additionalclasses='!text-start !tracking-[-1.44px]'>Why Developers Choose Workpeg</LandingHeadingText>
                        <div className='grid gap-[12px] content-start'>
                            <p className='text-[16px] lg:text-[20px] leading-[24px] lg:leading-[30px] text-[#101010] tracking-[-0.8px]'>
                                01.&#160;&#160; Built-in distribution via Peg Center
                            </p>
                            <p className='text-[16px] lg:text-[20px] leading-[24px] lg:leading-[30px] text-[#101010] tracking-[-0.8px]'>
                                02.&#160;&#160; Access to real businesses
                            </p>
                            <p className='text-[16px] lg:text-[20px] leading-[24px] lg:leading-[30px] text-[#101010] tracking-[-0.8px]'>
                                03.&#160;&#160; Secure infrastructure by default
                            </p>
                            <p className='text-[16px] lg:text-[20px] leading-[24px] lg:leading-[30px] text-[#101010] tracking-[-0.8px]'>
                                04.&#160;&#160; Monetization without building billing
                            </p>
                            <p className='text-[16px] lg:text-[20px] leading-[24px] lg:leading-[30px] text-[#101010] tracking-[-0.8px]'>
                                05.&#160;&#160; AI-first ecosystem
                            </p>
                        </div>
                    </div>
                </div>
            </LandingPageContainer> */}
            {/* <div className='w-full bg-grey-900 pt-[123px] pb-[95px] grid gap-[30px] items-center content-center justify-center '>
                <div className='grid gap-[12px] max-w-[90%] lg:max-w-[955px] m-auto'>
                    <LandingHeadingText additionalclasses='!text-white'>The Workpeg Developer Platform Is Opening Soon</LandingHeadingText>
                    <LandingSubText additionalclasses='!text-white !max-w-[480px] lg:!max-w-[546px] m-auto'>Join the waitlist to get early access to the SDK, tools, and first Peg publishing rights.</LandingSubText>
                </div>
                <LandingPageButton onClick={() => router.push(`https://forms.gle/CRwdZ2mLqbpUnSC8A`)}>Join the Developer Waitlist</LandingPageButton>
            </div> */}
            {/* <LandingPageContainer>
                <div className='w-full grid lg:flex gap-[50px] items-center justify-center lg:justify-between py-[104px] lg:py-[81px] '>
                    <LandingHeadingText>Developers</LandingHeadingText>
                    <div className='flex items-center gap-[16px] m-auto lg:m-0'>
                        <Link href='/terms-and-conditions' className='text-grey-900'>Terms</Link>
                        <Link href='https://www.workpeg.com/legal/workpeg-developer-terms-&-conditions.pdf' className='text-grey-900'>Legal</Link>
                    </div>
                    <p className='text-grey-900 max-w-[302px] text-center lg:text-start lg:whitespace-nowrap'>Copyright © 2025. Workpeg. All rights reserved.</p>
                </div>
            </LandingPageContainer> */}
        </div>
    );
};

export default LandingPage;